import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=48abab45&scoped=true&"
import script from "./NotificationList.vue?vue&type=script&lang=ts&"
export * from "./NotificationList.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=48abab45&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48abab45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48abab45')) {
      api.createRecord('48abab45', component.options)
    } else {
      api.reload('48abab45', component.options)
    }
    module.hot.accept("./NotificationList.vue?vue&type=template&id=48abab45&scoped=true&", function () {
      api.rerender('48abab45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notificationList/NotificationList.vue"
export default component.exports